import toast from 'react-hot-toast';
import { Haptics, NotificationType } from '@capacitor/haptics';
import { isNativePlatform } from '@/utils/capacitor';

function triggerHaptic(type: NotificationType): void {
  if (!isNativePlatform()) {
    return;
  }
  void Haptics.notification({ type });
}

type ToastOptions = { id?: string; haptic?: boolean };

export const showToast = {
  success: (message: string, options?: ToastOptions) => {
    if (options?.haptic !== false) {
      triggerHaptic(NotificationType.Success);
    }
    return toast.success(message, options?.id ? { id: options.id } : undefined);
  },
  error: (message: string, options?: { id?: string }) => {
    triggerHaptic(NotificationType.Error);
    return toast.error(message, options);
  },
  info: (message: string, options?: ToastOptions) => {
    return toast(message, options?.id ? { id: options.id } : undefined);
  },
  loading: (message: string) => toast.loading(message),
  promise: <T,>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((error: unknown) => string);
    }
  ) => toast.promise(promise, messages),
  dismiss: (toastId?: string) => toast.dismiss(toastId),
  dismissAll: () => toast.dismiss(),
};

export default showToast;
